import api from '../../../api/consultations/_historique-consultation'

const state = () => ({
    consultation_historiques: [],
    liste_consultations_patient: [],
})

// getters
const getters = {
    consultation_historiques: (state) => {
        return state.consultation_historiques
    },

    liste_consultations_patient: (state) => {
        return state.liste_consultations_patient
    },
}

// mutations
const mutations = {
    SET_CONSULTATION_HISTORIQUES(state, liste) {
        state.consultation_historiques = liste
    },

    SET_LISTE_CONSULTATIONS_PATIENT(state, liste) {
        state.liste_consultations_patient = liste
    },
}

// actions
const actions = {
    getListeHistoriqueConsultation({commit}, data){
        return new Promise((resolve,reject) => {
            api.getListeHistoriqueConsultation(data).then(
                response => {
                    commit('SET_CONSULTATION_HISTORIQUES', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getListeConsultationsPatient({commit}, demande){
        // A dossier owns its response locally; legacy ID-only callers still publish to Vuex.
        const lecture_locale = demande && typeof demande === 'object' && demande.lecture_locale === true
        const patient_id = lecture_locale ? demande.patient_id : demande
        return new Promise((resolve,reject) => {
            api.getListeConsultationsPatient(patient_id).then(
                response => {
                    if (!lecture_locale) commit('SET_LISTE_CONSULTATIONS_PATIENT', response)
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}
